import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { getFormattedTrailingStopItem } from "@shared/features/tradingTerminal/common/utils";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  getItemByName,
  getItemValue,
} from "@shared/features/configuration/utils";
import { TRAILING_STOP_TYPE_ITEM_NAME } from "@shared/features/configuration/constants";
import { OrderTypes } from "@shared/types";

const useInitializeTrailingStop = () => {
  const {
    getCreateGeneralDataQuery,
    setUseTrailing,
    useTrailing,
    isSignal,
    getSignalCreateGeneralDataQuery,
  } = useContext(TradingTerminalContext)!;
  const [isInitialized, setIsInitialized] = useState(false);

  const signalConfigurationTrailingStop =
    getSignalCreateGeneralDataQuery.data?.data.trailing_stop;
  const item = getCreateGeneralDataQuery.data?.data.configuration;
  const formattedTrailingStopItem = useMemo(
    () => getFormattedTrailingStopItem(item),
    [item]
  );

  const trailingStopTypeItem = getItemByName(
    TRAILING_STOP_TYPE_ITEM_NAME,
    formattedTrailingStopItem
  );
  const trailingStopTypeValue = getItemValue(trailingStopTypeItem);

  useEffect(() => {
    if (
      !isInitialized &&
      trailingStopTypeValue > 0 &&
      (!isSignal || !!signalConfigurationTrailingStop) &&
      !useTrailing[OrderTypes.STOP]
    ) {
      setUseTrailing(OrderTypes.STOP, true);
      setIsInitialized(true);
    }
  }, [isInitialized, trailingStopTypeValue, useTrailing[OrderTypes.STOP]]);

  return formattedTrailingStopItem;
};

export default useInitializeTrailingStop;
